module.exports = __webpack_public_path__ + "img/lee.f0ad2479.svg";